const setActiveSlideId = id => (dispatch, getState) =>
  dispatch({
    type: 'BUILDER:SET_ACTIVE_SLIDE',
    id
  })

const setPreviewDragging = isDragging => ({
  type: 'BUILDER:SET_PREVIEW_DRAGGING',
  isDragging
})

const openEditDialog = id => ({
  type: 'BUILDER:OPEN_EDIT_DIALOG',
  id
})

const openSettingsModal = () => ({
  type: 'BUILDER:OPEN_SETTINGS_MODAL'
})

const closeSettingsModal = () => ({
  type: 'BUILDER:CLOSE_SETTINGS_MODAL'
})

const openCreateSlideDialog = (slideType, slideParams) => ({
  type: 'BUILDER:OPEN_CREATE_SLIDE_DIALOG',
  slideType,
  slideParams
})

const closeCreateSlideDialog = () => ({
  type: 'BUILDER:CLOSE_CREATE_SLIDE_DIALOG'
})

const openEditSlideDialog = (slideType, slideId, slideParams) => ({
  type: 'BUILDER:OPEN_EDIT_SLIDE_DIALOG',
  slideType,
  slideId,
  slideParams
})

const closeEditSlideDialog = () => ({
  type: 'BUILDER:CLOSE_EDIT_SLIDE_DIALOG'
})

export {
  setActiveSlideId,
  setPreviewDragging,
  openEditDialog,
  openSettingsModal,
  closeSettingsModal,
  openCreateSlideDialog,
  closeCreateSlideDialog,
  openEditSlideDialog,
  closeEditSlideDialog
}
